import { Col, Row, Card, Button, Spin, Rate } from "antd";
import React, { FC, useState } from "react";
import styled from "styled-components";
import { MediumHeaderTitle, HeaderSubTitle } from "../Components/Text3D";
import { useQuery } from "@apollo/client";
import { GET_ALL_PRINTERS } from "../Apollo/graphql/Query";
import { useStoreActions, useStoreState } from "../myStore";
import { useHistory } from "react-router-dom";
import Img3D from "../Components/Model3D";
import HeaderComponent from "../Components/HeaderComponents";
import FooterPublic3D from "../Components/FooterPublic3D";

const MainWrapper = styled(Row)`
  min-height: 100vh;
`;
const ContentWrapper = styled(Col)`
  margin-top: 2rem;
  padding-bottom: 2rem;
  width: 100%;
  font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
`;
const InfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  .info-text {
    text-transform: capitalize;
  }
  .div-filament {
    margin-left: 0.5rem;
  }
`;
const CardX = styled(Card)`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08);

  .ant-card-cover {
    height: 250px;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    display: flex;
  }
  .ant-card-body {
    padding: 1rem;
  }
`;

const Img = styled.img`
  display: inline-block;
  width: auto;
  max-width: 100%;
  height: 100%;
  object-fit: contain;
`;

const UploadNewDesignSelectPageP: FC = () => {
  const history = useHistory();
  const { currentItem } = useStoreState((state: any) => state.cart);
  const { emptyCurrentItem, addToCart } = useStoreActions(
    (actions: any) => actions.cart
  );

  const [printers, setPrinters] = useState([]);

  const { loading } = useQuery(GET_ALL_PRINTERS, {
    variables: {
      pagination: {
        page: 1,
        limit: 100,
      },
      filter: {
        material: currentItem[0].material,
        color: currentItem[0].color,
      },
    },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setPrinters(data.printers.printers);
    }
  });
  const handleSelectClick = (printer: any) => {
    let printerId = printer._id;
    let printerName = printer.name;
    let sellerName = printer.owner.firstName;
    let printerOwnerId = printer.owner._id;
    const {
      filaments,
      price,
      length,
      width,
      height,
      active,
      postServiceCode,
      postalAddress,
      countryCode,
    } = printer;
    let items = currentItem.map((design) => {
      return {
        ...design,
        printerId,
        printerOwnerId,
        printerName,
        filaments,
        price,
        sellerName,
        length,
        width,
        height,
        active,
        postServiceCode,
        postalAddress,
        countryCode,
      };
    });
    items.forEach(item => {
      addToCart({
        ...item,
      });
    });
    emptyCurrentItem({});
    history.push("/design/cart");
  };

  return (
    <Spin spinning={loading}>
      <MainWrapper>
        <HeaderComponent />
        <ContentWrapper>
          <Col span={20} offset={2}>
            {currentItem && currentItem.material && (
              <div style={{ textAlign: "center", margin: "2rem 0" }}>
                <MediumHeaderTitle dark>
                  {`Showing printers with selected material "${
                    currentItem.material === "PLA_PLUS"
                      ? "PLA+"
                      : currentItem.material.replaceAll("_", " ")
                  }"`}
                </MediumHeaderTitle>
              </div>
            )}
            <Row gutter={[32, 32]} style={{ width: "100%" }}>
              {printers &&
                printers.map((printer: any) => {
                  return (
                    <Col
                      key={printer._id}
                      xl={{ span: 6 }}
                      md={{ span: 12 }}
                      sm={{ span: 24 }}
                      xs={{ span: 24 }}
                    >
                      <CardX
                        cover={
                          printer?.featuredImage?.endsWith(".stl") ? (
                            <Img3D url={printer.featuredImage} />
                          ) : (
                            <Img src={printer.featuredImage} alt="" />
                          )
                        }
                      >
                        <InfoDiv>
                          <div>
                            <strong className="info-text">
                              {printer?.name}
                            </strong>
                          </div>
                          <div>
                            <span className="info-text">
                              Brand: {printer?.brand}
                            </span>
                          </div>
                          <div>
                            <span className="info-text">
                              {printer?.length} X {printer?.width} X{" "}
                              {printer?.height}
                            </span>
                          </div>
                          <div>
                            <div className="info-text">
                              {"Filaments & Price:"}
                            </div>
                            {printer?.filaments.map((sf: any, idx) => {
                              return (
                                <span key={idx}>
                                  {sf.name === "PLA_PLUS"
                                    ? "PLA+"
                                    : sf.name.replaceAll("_", " ")}
                                  : {`$${sf.price},`}
                                </span>
                              );
                            })}
                          </div>
                          <div>
                            <span className="info-text">
                              Location: {printer?.postalAddress || ""}{" "}
                              {printer?.countryCode || ""}
                            </span>
                          </div>
                          <div>
                            <span className="info-text">
                              by: {printer?.owner?.firstName}
                            </span>
                          </div>
                          <hr
                            style={{
                              width: "100%",
                              border: "1px solid #D8D8D8",
                            }}
                          />
                          <span>
                            Rating:{" "}
                            <Rate
                              defaultValue={printer?.averageStarRating || 0}
                              style={{ paddingLeft: "1rem" }}
                              disabled
                            ></Rate>
                          </span>
                        </InfoDiv>
                        <Button
                          type="primary"
                          style={{
                            marginTop: "1rem",
                            width: "100%",
                            height: "48px",
                            fontSize: "20px",
                          }}
                          onClick={() => {
                            handleSelectClick(printer);
                          }}
                        >
                          SELECT THIS PRINTER
                        </Button>
                      </CardX>
                    </Col>
                  );
                })}
              {!loading && printers.length === 0 && (
                <Col span={24}>
                  <div style={{ textAlign: "center", margin: "2rem 0" }}>
                    <HeaderSubTitle dark>
                      No printers are available in this selected material and
                      colour
                    </HeaderSubTitle>
                  </div>
                </Col>
              )}
            </Row>
          </Col>
        </ContentWrapper>
        <FooterPublic3D />
      </MainWrapper>
    </Spin>
  );
};
export default UploadNewDesignSelectPageP;
